import { PureComponent } from 'react';

import { Button } from 'components/Button/Button';
import { ButtonAsA } from 'components/Button/ButtonAsA';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import { OverlayModalHeader } from 'components/OverlayModal/OverlayModalHeader';
import LTEBox from 'containers/LTEBox';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';
import OverviewPropTypes from '../OverviewPropTypes';
import TableColorForm from './TableColorForm';
import TextRowForm from './TextRowForm';

export default class AddWidget extends PureComponent {
  static propTypes = {
    allMessages: PropTypes.object.isRequired,
    Chart: OverviewPropTypes.Chart,
    columnIndex: OverviewPropTypes.columnIndex,
    editWidget: OverviewPropTypes.editWidget,
    layout: OverviewPropTypes.layout,
    msg: PropTypes.object.isRequired,
    onCreateReportGroup: PropTypes.func.isRequired,
    onFetchReports: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    onStepChange: PropTypes.func.isRequired,
    onToggleConfirmDialog: PropTypes.func.isRequired,
    onUpdateReportGroup: PropTypes.func.isRequired,
    onWidgetSelect: PropTypes.func.isRequired,
    reports: OverviewPropTypes.reports,
    reportsGroups: OverviewPropTypes.reportsGroups,
    rowIndex: OverviewPropTypes.rowIndex,
    selectedGroup: OverviewPropTypes.selectedGroup,
    step: PropTypes.number,
    textRow: OverviewPropTypes.textRow,
    widget: PropTypes.string,
    widgetIndex: OverviewPropTypes.widgetIndex,
    widgetProps: OverviewPropTypes.widgetProps,
    widgets: PropTypes.object.isRequired,
  };

  static defaultProps = {
    editWidget: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      widget: props.widget || null,
    };
  }

  getWidgetIcons = (widget) => {
    switch (widget) {
      case 'TextRow':
        return (
          <span className='float-right'>
            <i className='fa fa-list ml-2 inline-block' />
          </span>
        );
      case 'NetworkVendorMix':
        return (
          <span className='float-right'>
            <i className='fa fa-pie-chart ml-2 inline-block' />
          </span>
        );
      case 'HostVendorMix':
        return (
          <span className='float-right'>
            <i className='fa fa-pie-chart ml-2 inline-block' />
          </span>
        );
      case 'TableColor':
        return (
          <span className='float-right'>
            <i className='fa fa-table ml-2 inline-block' />
            <i className='fa fa-bar-chart ml-2 inline-block' />
            <i className='fa fa-pie-chart ml-2 inline-block' />
          </span>
        );
      case 'DeviceChart':
        return (
          <span className='float-right'>
            <i className='fa fa-bar-chart ml-2 inline-block' />
          </span>
        );
      default:
        return null;
    }
  };

  getWidgets = () => {
    const { widgets, msg } = this.props;
    const widgetItems = Object.keys(widgets).map((widget) => {
      return (
        <li key={widget} className='dashboard__add-widget-item'>
          <ButtonAsA onClick={this.handleSelectNext(widget)}>
            <span className='flow-root'>
              <div className='float-left'>
                <div className='font-bold'>{widgets[widget].title}</div>
                <div>{get(msg, ['dialog', 'widgetsDescription', widget])}</div>
              </div>
              {this.getWidgetIcons(widget)}
            </span>
          </ButtonAsA>
        </li>
      );
    });
    return widgetItems;
  };

  getSettingsForm = () => {
    const {
      allMessages,
      Chart,
      columnIndex,
      editWidget,
      layout,
      msg,
      onCreateReportGroup,
      onFetchReports,
      onRequestClose,
      onToggleConfirmDialog,
      onUpdateReportGroup,
      reports,
      reportsGroups,
      rowIndex,
      selectedGroup,
      textRow,
      widgetIndex,
      widgetProps,
    } = this.props;
    const { widget } = this.state;
    switch (widget) {
      case 'TextRow':
        return (
          <TextRowForm
            columnIndex={columnIndex}
            editWidget={editWidget}
            layout={layout}
            msg={msg}
            onClose={editWidget ? onRequestClose : this.handleBack}
            onSubmit={this.handleSelectWidget}
            rowIndex={rowIndex}
            textRow={textRow}
            widgetName={widget}
            widgetProps={widgetProps}
          />
        );
      case 'TableColor':
        return (
          <TableColorForm
            allMessages={allMessages}
            Chart={Chart}
            columnIndex={columnIndex}
            editWidget={editWidget}
            layout={layout}
            msg={msg}
            onClose={editWidget ? onRequestClose : this.handleBack}
            onCreateReportGroup={onCreateReportGroup}
            onFetchReports={onFetchReports}
            onSubmit={this.handleSelectWidget}
            onToggleConfirmDialog={onToggleConfirmDialog}
            onUpdateReportGroup={onUpdateReportGroup}
            reports={reports}
            reportsGroups={reportsGroups}
            rowIndex={rowIndex}
            selectedGroup={selectedGroup}
            widgetIndex={widgetIndex}
            widgetName={widget}
            widgetProps={widgetProps}
          />
        );
      default:
        return <div />;
    }
  };

  handleSelectWidget = handleEvent(
    (values, widget, type, disableLayoutUpdate) => {
      const { onWidgetSelect } = this.props;
      onWidgetSelect(widget, values, type, disableLayoutUpdate);
    },
  );

  handleSelectNext = (widget) => (e) => {
    e.preventDefault();
    const { onWidgetSelect, onStepChange } = this.props;
    switch (widget) {
      case 'NetworkVendorMix':
      case 'HostVendorMix':
      case 'DeviceChart':
        onWidgetSelect(widget);
        break;
      default:
        this.setState({ widget }, () => onStepChange(2));
    }
  };

  handleBack = handleEvent(() => {
    this.setState({ widget: null }, () => this.props.onStepChange(1));
  });

  render() {
    const { msg, onRequestClose, step, editWidget } = this.props;
    if (step === 1) {
      return (
        <OverlayModal onClose={onRequestClose}>
          <OverlayModalHeader>
            <h4>{get(msg, ['dialog', 'title'])}</h4>
          </OverlayModalHeader>
          <OverlayModalBody>
            <div className='nav nav-stacked'>{this.getWidgets()}</div>
          </OverlayModalBody>
          <OverlayModalFooter>
            <Button variant='secondary' type='button' onClick={onRequestClose}>
              {get(msg, ['dialog', 'btnClose'])}
            </Button>
          </OverlayModalFooter>
        </OverlayModal>
      );
    }
    if (step === 2) {
      return (
        <LTEBox
          bodyComponent={this.getSettingsForm()}
          bodyClassName='box-body no-padding'
          className='box box-primary'
          title={get(msg, ['dialog', editWidget ? 'editTitle' : 'title'])}
        />
      );
    }
    return null;
  }
}
